<template>
  <section class="couponRules">
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <p class="question">{{ item.question }}</p>
        <div class="answer" v-for="(el, index) in item.answer" :key="index">
          <p>{{ el }}</p>
        </div>
      </li>
    </ul>
    <p>如有疑问，请联系我们</p>
    <p>客服电话：0755-86332133(分机号835)</p>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "rule",
  data() {
    return {
      list: [
        {
          question: "Q:什么是格隆汇优惠券？",
          answer: [
            "格隆汇优惠券是对外发行和认可的现金抵用券，可在格隆汇商城产品中下单使用，满足使用条件可抵扣相应余额。"
          ]
        },
        {
          question: "Q : 优惠券有哪些类型？",
          answer: [
            "格隆汇平台发放的优惠券分为以下类型：指定专栏优惠券、所有专栏通用券和满减优惠券，满足使用条件方可抵扣相应金额。"
          ]
        },
        {
          question: "Q : 优惠券如何获取？",
          answer: [
            "优惠券可在格隆汇举办的优惠活动中领取，以后还会支持更多领取方式。"
          ]
        },
        {
          question: "Q : 优惠券的使用条件？",
          answer: [
            "1、仅限领取优惠券的账号使用，不可提现，买卖、兑现、转赠他人。 ",
            "2、仅限在线支付使用，买个专栏购买时只能使用一张优惠券，不能与其他券叠加使用，且不找零。",
            "3、优惠券需登录后领取，且领取后在有效期内使用。"
          ]
        }
      ]
    };
  },
  created() {},
  mounted() {
    document.title = "优惠券使用规则";
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.couponRules {
  position: relative;
  padding: 40px;
  max-width: 750px;
  width: 100%;
  text-align: left;
  // background-color: #282C37;
  background: #ffffff;
  li {
    padding: 35px 0 35px;
    border-bottom: 1px solid rgba(235, 235, 235, 1);
  }
  .question {
    margin-bottom: 30px;
    font-size: 30px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
  }
  .answer {
    // margin-top: 30px;
    p {
      font-size: 28px;
      letter-spacing: 1px;
      color: rgba(102, 102, 102, 1);
      line-height: 38px;
    }
  }
  > p {
    margin-top: 30px;
    font-size: 28px;
    color: rgba(153, 153, 153, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/couponRules.vue